import * as React from "react";
import { api } from "src/services/api";
import { route, routeApi } from "src/services/browser";
import ModalRegistrazione from "@src/components/frontend/modals/ModalRegistrazione";
import FormSelect from "@src/components/ui/FormSelect";
import FormCheckBox from "@src/components/ui/FormCheckBox";
import FormInput from "@src/components/ui/FormInput";


interface Props {
    header: string,
    onSave?: any,
    onCancel?: any
}

interface State {
    _aggiungiscuola_nome?: string,
    _aggiungiscuola_citta?: string,
    _aggiungiscuola_indirizzo?: string
    _aggiungiscuola_telefono?: string
    _aggiungiscuola_email?: string
}

export default class ModalAggiungiScuola extends React.Component<Props, State> {
    handleChange(field, value) {
        this.setState({
            [field]: value
        });
    }

    validateEmail(email) {
        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
    }

    async onSave() {

        if(this.state === null || this.state._aggiungiscuola_nome === undefined || this.state._aggiungiscuola_citta === undefined || this.state._aggiungiscuola_indirizzo === undefined || this.state._aggiungiscuola_telefono === undefined || this.state._aggiungiscuola_email === undefined ) {
            alert('Compilare correttamente tutti i campi.');
            return;
        }
        if (!this.validateEmail(this.state._aggiungiscuola_email)) {
            alert('Inserire correttamente email.');
            return;
        }

        let data = {
            nome: this.state._aggiungiscuola_nome,
            comune: this.state._aggiungiscuola_citta,
            indirizzo: this.state._aggiungiscuola_indirizzo,
            telefono: this.state._aggiungiscuola_telefono,
            email: this.state._aggiungiscuola_email,
        };

        const result = await api({
            url: routeApi('scuola.proponiNuova', { ...data }),
            method: 'post',
            rawRespone: true
        });
        console.log(result)

        if(this.props.onSave)
            this.props.onSave(result);
    }

    render() {
        let competenze = [
            {
                key: "Photoshop",
                value: "Photoshop"
            },
            {
                key: "Illustrator",
                value: "Illustrator"
            },
            {
                key: "InDesign",
                value: "InDesign"
            },
            {
                key: "InVision",
                value: "InVision"
            }
        ];

        const box = (
          <div className="modal-box-inner">
              <div className="box-icon">
                  <span className="icon-voice_presentation"></span>
              </div>
              <div className="row headline">
                  <h3>Segnalaci una nuova scuola!</h3>
                  <br />
                  <h6>Se hai cercato una scuola e non l'hai trovata, faccelo sapere. <br /> Puoi compilare questo form. Noi faremo il resto.</h6>
              </div>
          </div>
        );

        return (
            <ModalRegistrazione box={box} header={this.props.header} onSave={this.onSave.bind(this)} onCancel={this.props.onCancel}>
                <div className={"block-qa"}>
                    <div className={"row"} style={{marginBottom: "0px"}}>
                        <div className={"col-md-12"}>
                            <FormInput type={"text"} label={"Nome Scuola"} placeholder={"Nome Scuola"} required name={"_aggiungiscuola_nome"} onChange={this.handleChange.bind(this)} />
                        </div>
                    </div>
                    <div className={"row"} style={{marginBottom: "0px"}}>
                        <div className={"col-md-12"}>
                            <FormInput type={"text"} label={"Città"} placeholder={"Città"} required name={"_aggiungiscuola_citta"} onChange={this.handleChange.bind(this)} />
                        </div>
                    </div>
                    <div className={"row"} style={{marginBottom: "0px"}}>
                        <div className={"col-md-12"}>
                            <FormInput type={"text"} label={"Indirizzo"} placeholder={"Indirizzo"} required name={"_aggiungiscuola_indirizzo"} onChange={this.handleChange.bind(this)} />
                        </div>
                    </div>
                    <div className={"row"} style={{marginBottom: "0px"}}>
                        <div className={"col-md-6"}>
                            <FormInput type={"text"} label={"Telefono"} placeholder={"Telefono"} required name={"_aggiungiscuola_telefono"} onChange={this.handleChange.bind(this)} />
                        </div>
                        <div className={"col-md-6"}>
                            <FormInput type={"text"} label={"Email"} placeholder={"Email"} required name={"_aggiungiscuola_email"} onChange={this.handleChange.bind(this)} />
                        </div>
                    </div>
                </div>
            </ModalRegistrazione>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/frontend/modals/ModalAggiungiScuola.tsx